import { mapActions, mapGetters } from 'vuex';
import marketContractHorizontalSushi from '@/components/market/market-contract-horizontal-sushi/market-contract-horizontal-sushi.vue';
import marketContractsListHeaderSushi from '@/components/market/market-contracts-list-header-sushi/market-contracts-list-header-sushi.vue';

const NARROW_CONTAINER_WIDTH = 900;

export default {
  props: {
    openNewTab: {
      type: Boolean,
      default: false,
    },
    market: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isNarrowContainer: false,
      containerResizeObserver: null,
    };
  },
  components: {
    marketContract: marketContractHorizontalSushi,
    marketContractsListHeaderSushi,
  },
  computed: {
    ...mapGetters('user', ['isLoggedIn']),
  },
  methods: {
    ...mapActions('onboarding', ['showOnboardingStep']),
    updateContainerLayoutMode() {
      const containerWidth = this.$el ? this.$el.clientWidth : 0;
      this.isNarrowContainer = containerWidth > 0 && containerWidth < NARROW_CONTAINER_WIDTH;
    },
    teardownResizeObserver() {
      if (this.containerResizeObserver) {
        this.containerResizeObserver.disconnect();
        this.containerResizeObserver = null;
      }
    },
    setupResizeObserver() {
      this.teardownResizeObserver();
      this.updateContainerLayoutMode();
      if (typeof ResizeObserver === 'undefined' || !this.$el) {
        return;
      }
      this.containerResizeObserver = new ResizeObserver(() => {
        this.updateContainerLayoutMode();
      });
      this.containerResizeObserver.observe(this.$el);
    },
    onContractClick(data) {
      const { contractId } = data;
      const route = {
        name: 'market-details',
        params: {
          marketId: this.market.marketId,
          marketUrl: this.market.marketUrl,
        },
        query: {
          contractId,
        },
      }
      if (!this.openNewTab) {
        this.$router.push(route);
      } else {
        const resolved = this.$router.resolve(route);
        window.open(resolved.href, "_blank");
      }
    },
  },
  mounted() {
    this.setupResizeObserver();
  },
  beforeDestroy() {
    this.teardownResizeObserver();
  },
};



// WEBPACK FOOTER //
// ./src/components/cms/market-contract-list-v2-embed/market-contract-list-v2-embed.js